'use strict'

import modal from 'Modules/modal'

const J_SEARCH_BOX = '.searchbox'
const OVERLAYSEARCH = document.querySelector('.overlay-search')

let abortControllers = []
// Vue app de la barre de recherche
new Vue({
    el: '#vueSearchApp',
    data: function () {
        return {
            searchText: '',
            searchResult: null,
            showResult: false,
            showCross: false,
            action: '',
            activeInput: false,
            isMobile: document.querySelector('.main-container-mobile') !== null,
            defaultAbortReason: 'Mise à jour contenu de la recherche',
            isFocused: false,
            typewriterInterval: null,
            currentIndex: 0,
            placeholders: ['doudoune noire', 'chemise blanche', 'baskets Nike'],
            currentCharIndex: 0,
            inputValue: ''
        }
    },
    created: function () {
        var appContainer = document.getElementById('vueSearchAppContainer')

        if (appContainer) {
            appContainer.style.display = ''
        }

        if (document.getElementById('jsSearchResult')) {
            document.getElementById('jsSearchResult').classList.remove('hidden')
        }

        if (document.querySelector('#vueSearchApp')) {
            this.searchText =
                document.querySelector('#vueSearchApp').dataset.value

            this.action =
                document.querySelector('.j_search_button').dataset.action
        }
    },
    mounted() {
        this.checkAndInitAnimation()
    },
    beforeUnmount() {
        this.stopAnimation()
    },
    methods: {
        Search() {
            window.location.href = encodeURI(
                this.action + '?re=' + this.searchText
            )
        },
        SuggestSearch() {
            const controller = new AbortController()
            const signal = controller.signal

            abortControllers.forEach((controller) => {
                controller.abort(this.defaultAbortReason)
            })

            abortControllers = []
            abortControllers.push(controller)

            const _self = this

            _self.searchResult = null

            _self.showCross = _self.searchText.length > 0

            if (_self.searchText.length < 3) {
                _self.showResult = false
                return
            }

            fetch('/Catalogue/?re=' + this.searchText + '&suggest=true', {
                signal
            })
                .then((response) => {
                    return response.json().then(function (json) {
                        json.Suggestions.Familles.forEach((data) => {
                            data.Libelle = _self.Highlight(
                                data.Libelle,
                                _self.Capitalize
                            )
                        })

                        json.Suggestions.Categories.forEach((data) => {
                            data.Libelle = _self.Highlight(
                                data.Libelle,
                                _self.Capitalize
                            )
                        })

                        json.Suggestions.Marques.forEach((data) => {
                            data.Libelle = _self.Highlight(
                                data.Libelle,
                                _self.ToUpperCase
                            )
                        })

                        json.Autocomplete.forEach((data) => {
                            data.AutocompleteRaw = data.Autocomplete
                            data.Autocomplete = _self.Highlight(
                                data.Autocomplete,
                                _self.Capitalize
                            )
                        })

                        _self.showResult = true
                        _self.searchResult = json
                    })
                })
                .catch((error) => {
                    if (error === this.defaultAbortReason) {
                        return
                    }

                    throw new Error(error)
                })
        },
        ToggleClassElement(element, classElement) {
            if (!element) {
                return
            }
            if (element.classList.contains(classElement)) {
                element.classList.remove(classElement)
                return
            }
            element.classList.add(classElement)
        },
        ToggleGap(element) {
            if (!element) return

            function hasGap20(element) {
                if (!element) {
                    return false
                }
                const styles = window.getComputedStyle(element)
                const gap = styles.gap

                return gap.includes('20px') || gap === '20px 20px'
            }

            hasGap20(element)
                ? (element.style.gap = 'unset')
                : (element.style.gap = '20px')
        },
        ToggleMobile() {
            if (!this.isMobile) return

            this.ToggleClassElement(
                document.querySelector('.block-searchbox'),
                'searchBox--focus'
            )
            this.ToggleClassElement(
                document.querySelector('#header-filtres'),
                'hidden'
            )
            this.ToggleClassElement(
                document.querySelector('.j_more_filters'),
                'hidden'
            )
            this.ToggleClassElement(
                document.querySelector('#burgermenu'),
                'hidden'
            )
            this.ToggleGap(document.querySelector('.container-header'))
            this.ToggleClassElement(
                document.querySelector('.close-searchbox'),
                'hidden'
            )
        },
        Deploy() {
            this.activeInput = true

            if (document.querySelector('.searchbox')) {
                document.querySelector('.searchbox').classList.add('open')
            }

            if (document.querySelector('#header')) {
                document.querySelector('#header').classList.add('openSearch')
                document.querySelector('#header').classList.remove('container')
            }

            if (OVERLAYSEARCH) {
                OVERLAYSEARCH.classList.remove('hidden-xs')
            }
            this.ToggleMobile()
            document.querySelector('body').classList.add('no-scroll')
            if (this.isMobile) {
                this.ToggleGap(document.querySelector('.container-header'))
            }
        },
        Clear() {
            this.showResult = false
            this.searchText = ''
            this.showCross = false
        },
        Close() {
            this.activeInput = false
            this.showCross = false
            this.showResult = false
            if (document.querySelector('.searchbox')) {
                document.querySelector('.searchbox').classList.remove('open')
            }

            if (document.getElementById('header')) {
                document.querySelector('#header').classList.remove('openSearch')
            }
            this.ToggleMobile()
            if (OVERLAYSEARCH) {
                OVERLAYSEARCH.classList.add('hidden-xs')
            }

            document.querySelector('body').classList.remove('no-scroll')
        },
        Highlight(chaine, tranformer) {
            const replace = tranformer(this.searchText)
            const result = chaine.replace(
                new RegExp(this.searchText, 'gi'),
                String.prototype.concat('<strong>', replace, '</strong>')
            )
            return result
        },
        Capitalize(chaine) {
            chaine = chaine.toLowerCase()
            return chaine.charAt(0).toUpperCase() + chaine.slice(1)
        },
        ToUpperCase(chaine) {
            return chaine == null ? '' : chaine.toUpperCase()
        },
        checkAndInitAnimation() {
            if (!this.typewriterInterval) {
                this.startAnimation()
            }
        },
        startAnimation() {
            if (this.typewriterInterval) return
            this.typeWord()
        },

        typeWord() {
            const input = this.$refs.searchInput
            if (!input) return

            const baseText = 'Rechercher '
            const currentWord = this.placeholders[this.currentIndex]

            this.typewriterInterval = setInterval(
                () => {
                    // MODE TYPING
                    if (!this.isDeleting) {
                        if (this.currentCharIndex <= currentWord.length) {
                            input.placeholder =
                                baseText +
                                currentWord.substring(0, this.currentCharIndex)
                            this.currentCharIndex++
                        } else {
                            // Mot complet, pause puis effacer
                            clearInterval(this.typewriterInterval)
                            setTimeout(() => {
                                this.isDeleting = true
                                this.typeWord()
                            }, 2000)
                        }
                    }
                    // MODE DELETING
                    else {
                        if (this.currentCharIndex > 0) {
                            this.currentCharIndex--
                            input.placeholder =
                                baseText +
                                currentWord.substring(0, this.currentCharIndex)
                        } else {
                            // Effacement terminé next mot
                            clearInterval(this.typewriterInterval)
                            this.isDeleting = false
                            this.currentIndex =
                                (this.currentIndex + 1) %
                                this.placeholders.length

                            setTimeout(() => {
                                if (!this.isFocused) {
                                    this.typeWord()
                                }
                            }, 300) //  pause avant de retaper
                        }
                    }
                },
                this.isDeleting ? 40 : 80
            ) // Vitesse de frappe
        },

        stopAnimation() {
            if (this.typewriterInterval) {
                clearInterval(this.typewriterInterval)
                this.typewriterInterval = null
            }
        },

        handleFocus() {
            this.isFocused = true
            this.stopAnimation()

            const input = this.$refs.searchInput
            if (input) {
                input.placeholder = `Rechercher ${
                    this.placeholders[this.currentIndex]
                }`
            }
        },

        handleBlur() {
            this.isFocused = false
            this.currentCharIndex = 0
            this.typeWord()
        }
    }
})
